import { TYPE_MYTEL_ERROR_CODE, TYPE_MYTEL_MAGICWHEEL, TYPE_MYTEL_MATH_MATHCH, TYPE_MYTEL_REVENUE, TYPE_MYTEL_VM } from "./type";

const initialState = {
  revenue: [],
};

export const reducerMytel = (state = initialState, action) => {
  switch (action.type) {
    case TYPE_MYTEL_REVENUE:
      return {
        ...state,
        revenue: action.payload,
      };
    default:
      return state;
  }
};

export const reducerMytelErrorCode = (state = initialState, action) => {
  switch (action.type) {
    case TYPE_MYTEL_ERROR_CODE:
      return {
        ...state,
        revenue: action.payload,
      };
    default:
      return state;
  }
};

export const reducerMytelVm = (state = initialState, action) => {
  switch (action.type) {
    case TYPE_MYTEL_VM:
      return {
        ...state,
        revenue: action.payload,
      };
    default:
      return state;
  }
};
export const reducerMagicWheel = (state = initialState, action) => {
  switch (action.type) {
    case TYPE_MYTEL_MAGICWHEEL:
      return {
        ...state,
        revenue: action.payload,
      };
    default:
      return state;
  }
};

export const reducerMathMatch = (state = initialState, action) => {
  switch (action.type) {
    case TYPE_MYTEL_MATH_MATHCH:
      return {
        ...state,
        revenue: action.payload,
      };
    default:
      return state;
  }
};
